// Loader.js
import React from "react";
import "../styles/Loader.css"; // Ensure you have a CSS file for styling the loader

export default function Loader() {
  return (
    <div className="loader-overlay">
      <div className="loader"></div>
    </div>
  );
}
